import React, { FC, Fragment } from 'react';
import TermsAgreementGlobal from 'app/components/auth/TermsAgreementGlobal';
import TermsAgreementKorea from 'app/components/auth/TermsAgreementKorea';
import { useQuery } from 'app/components/Contexts';
import { useBrand } from '../OrganizationContext';
import { ENGOO_KOREA_BRAND_ID } from 'app/constants/Brands';

interface IProps {
  showValidationErrors: boolean;
  setAgree: (checked: boolean) => void;
}

/**
 * Renders the appropriate Terms of a Agreement for signup.
 */
const TermsAgreement: FC<IProps> = ({ showValidationErrors, setAgree }) => {
  const brand = useBrand();
  const query = useQuery();
  return (
    <Fragment>
      {query.korean_signup === '1' || brand.id === ENGOO_KOREA_BRAND_ID ?
        <TermsAgreementKorea
          showValidationErrors={showValidationErrors}
          setAgree={setAgree}
        /> :
        <TermsAgreementGlobal
          showValidationErrors={showValidationErrors}
          setAgree={setAgree}
        />}
    </Fragment>
  );
};

export default TermsAgreement;
